export default {
    recipes: {
        metaTitle: 'Athlisis - Recipe',
        empty: {
            title: 'Recipe not found',
            subtitle: 'You have either typed a wrong hyperlink, or the recipe is not available anymore.'
        },
        recipe: 'Recipe',
        nutritionLabel: 'Nutrition Label'
    },
    questionnaire: {
        saved: {
            title: 'Your answers have been saved!',
            text: 'Your responses are now available. You do not need to take any further action. You can close this page, or use the same link at any time to update your responses.',
            editAgain: 'Edit my answers'
        }
    },
    couponUse: {
        title: 'Type your coupon to view transaction history.',
        code: 'Coupon code',
        password: 'Password',
        view: 'View transactions',
        back: 'Back to last screen',
        placeholder: {
            code: 'Your coupon code',
            password: 'Your password'
        }
    }
}